import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { registerMaisEguFailed, registerMaisEguSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  APPLICATION_STATUS, BACKEND_URL,
} from '../../../configs';

export default function* registerMaisEgu(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/register-mais-egu`;
    const pool = action.payload;
    pool.status = APPLICATION_STATUS.NEW;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield getBodyJson(response);
    if (response.status === OK && data) {
      yield put(registerMaisEguSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(registerMaisEguFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(registerMaisEguFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
